<div class="dialog-container">
    <div class="dialog-icon-container">
        <i class="bi bi-plus-lg"></i>
    </div>
    <h1 mat-dialog-title>Agregar plantilla</h1>
    <div mat-dialog-content>
        <mat-form-field>
            <input matInput [(ngModel)]="data.name">
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onCancel()">
            Cancelar
        </button>
        <button mat-button [mat-dialog-close]="data.name">
            Guardar
        </button>
    </div>
</div>